import { render, staticRenderFns } from "./HotelBuildingRoomForm.vue?vue&type=template&id=5b36d738&"
import script from "./HotelBuildingRoomForm.vue?vue&type=script&lang=js&"
export * from "./HotelBuildingRoomForm.vue?vue&type=script&lang=js&"
import style0 from "./HotelBuildingRoomForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports